module.exports = __webpack_public_path__ + "static/img/10.1c6c0c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jlbs/10.png
// module id = hkXi
// module chunks = 0